import { DeviceStethoscope, EventBase } from "@vp/models";

export interface DeviceStethoscopesUpdatedEventArgs {
  deviceUserId: string;
  deviceStethoscopes: DeviceStethoscope[];
}

export class DeviceStethoscopeUpdatedEvent extends EventBase<DeviceStethoscopesUpdatedEventArgs> {
  constructor(args: DeviceStethoscopesUpdatedEventArgs) {
    super();
    this.args = args;
  }
}
